




























































































































































































import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

import { DatasetListing } from '@/types';
import { actions } from '@/controller';
import { browseDatasetMenu } from '../state';
import { useClient, useDatasets } from '@/use';

const adminCheck = computed(() => store.getters.isAdmin);

const headers = [
  { text: 'Dataset ID', value: '_id', width: '30%' },
  { text: 'Study', value: 'study_type', width: '12%', sortable: false },
  { text: 'Subject', value: 'subject_type', width: '12%', sortable: false },
  { text: 'Created', value: 'created_at', width: '15%' },
  { text: 'Samples', value: 'count', width: '8%', align: 'end' },
  { text: 'Flagged', value: 'flagged', width: '8%', align: 'end' },
  { text: 'Validated', value: 'validation_only', width: '10%', align: 'center', sortable: false },
  { text: adminCheck.value ? '' : '', value: 'actions', width: '5%', align: 'center', sortable: false },
];

export default defineComponent({
  name: 'BrowseDatasetMenu',
  setup() {
    const {
      loading,
      items,
      selected,
      fetch,
      dataTableInfo,
      datasetTableOptions,
      itemsPerPage,
      search,
      filterStudyType,
      filterSubjectType,
      filterValidationOnly,
      onlyShowFlagged,
    } = useDatasets();

    const client = useClient();
    const subjectTypes = computed(() => store.state.application.applicationData?.lists.subject_types.map((st) => st.toUpperCase()));
    const studyTypes = computed(() => store.state.application.applicationData?.lists.study_types);
    const validationOnlys = [true, false];

    const closeDialog = () => { browseDatasetMenu.value = false; };
    const deleteDialogActive = ref(false);

    const selectedDataset = ref<DatasetListing | null>(null);

    function openDeleteDialog(item: DatasetListing) {
      selectedDataset.value = item;
      deleteDialogActive.value = true;
    }

    function closeDeleteDialog() {
      selectedDataset.value = null;
      deleteDialogActive.value = false;
    }

    function formatDate(value: string) {
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
    }

    async function loadRemoteDataset(dataset: DatasetListing) {
      closeDialog();
      // eslint-disable-next-line no-underscore-dangle
      actions.fetchDataset(dataset._id, false);
    }

    async function deleteSelectedDataset() {
      const dataset = selectedDataset.value;
      if (dataset === null) {
        return;
      }

      // Set loading to true before request, since the request can take a long time
      loading.value = true;

      // Delete dataset
      await client?.deleteRemoteDataset(dataset);
      closeDeleteDialog();

      // eslint-disable-next-line no-underscore-dangle
      if (store.state.dataset.datasetId === dataset._id) {
        actions.clearDataset();
      }
      selectedDataset.value = null;
      fetch();
    }

    // Fetch Datasets
    watch(browseDatasetMenu, (val) => {
      if (!val) { return; }

      // Fetch datasets
      fetch();
    });

    return {
      headers,
      studyTypes,
      subjectTypes,
      validationOnlys,
      loading,
      search,
      filterStudyType,
      filterSubjectType,
      filterValidationOnly,
      onlyShowFlagged,
      items,
      browseDatasetMenu,
      selected,
      closeDialog,
      loadRemoteDataset,
      dataTableInfo,
      datasetTableOptions,
      itemsPerPage,
      openDeleteDialog,
      deleteDialogActive,
      selectedDataset,
      closeDeleteDialog,
      deleteSelectedDataset,
      formatDate,
      adminCheck,
    };
  },
});
